import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as FeedItemApi from 'web-app/react/entities/feed/items/api';

import * as Actions from './actions';

const comment = action$ =>
    action$.ofType(Actions.comment.type).mergeMap(({payload}) =>
        Observable.concat(
            FeedItemApi.comment(payload.originatorId, payload.body)
                .mergeMap(response =>
                    Observable.concat(
                        Observable.of(Actions.commentSuccess.action(payload.originatorId, response.comment)),
                    ),
                )
                .catch(e =>
                    Observable.concat(
                        Observable.of(Actions.commentFailed.action({error: e, originatorId: payload.originatorId})),
                    ),
                ),
        ),
    );

const deleteComment = action$ =>
    action$.ofType(Actions.deleteComment.type).mergeMap(({payload}) =>
        FeedItemApi.deleteComment(payload.commentId)
            .map(() => Actions.deleteCommentSuccess.action(payload.originatorId, payload.commentId))
            .catch(e => Observable.of(Actions.deleteCommentFailed.action(e))),
    );

export default combineEpics(comment, deleteComment);
